import * as React from "react";
import "./ProjectTimelineStyle.css";

export interface ITeam {
    name: string;
    designation: string;
    affiliation: string;
    contact_info: string[];
}

interface IProps {
    teams: ITeam[];
}

const ProjectTeam = (props: IProps) => {
    const extractContactDetails = (contact_info: string[]) => {
        const emailRegex = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi;
        const phoneRegex = /(\+?\d{1,4}[\s.-]?)?(\(?\d{3}\)?[\s.-]?)?\d{3}[\s.-]?\d{4}/g;

        const emails: string[] = [];
        const phones: string[] = [];

        contact_info.forEach(info => {
            const emailMatch = info.match(emailRegex);
            if (emailMatch) {
                emails.push(...emailMatch);
            }

            const phoneMatch = info.match(phoneRegex);
            if (phoneMatch) {
                phones.push(...phoneMatch);
            }
        });

        return { emails, phones };
    };

    return (
        <div className="table-container">
            <p className="TimelineText">Project Team</p>
            <table>
                <thead>
                <tr>
                    <th>Name / Designation</th>
                    <th>Contact No.</th>
                    <th>Email</th>
                </tr>
                </thead>
                <tbody>
                {props?.teams?.length > 0 ? (
                    props.teams.map((team: ITeam, index: number) => {
                        const { emails, phones } = extractContactDetails(team.contact_info);
                        return (
                            <tr key={`team_tr_${index}`}>
                                <td key={`team_td_name_${index}`} style={{ color: "black" }}>
                                    {`${team.name} (${team.designation})`}
                                </td>
                                <td key={`team_td_phone_${index}`} style={{ color: "black" }}>
                                    {phones.length > 0 ? phones.join(", ") : "N/A"}
                                </td>
                                <td key={`team_td_email_${index}`} style={{ color: "black" }}>
                                    {emails.length > 0 ? emails.join(", ") : "N/A"}
                                </td>
                            </tr>
                        );
                    })
                ) : (
                    <tr>
                        <td colSpan={3} style={{ textAlign: "center" }}>
                            No Focal Person Information Available
                        </td>
                    </tr>
                )}
                </tbody>
            </table>
        </div>
    );
};

export default ProjectTeam;
